export const WORKSPACE_TAB_REMOVED = 'WORKSPACE_TAB_REMOVED' as const;
